/**
 * Shared Business Type Configuration
 * Used by: Admin App (onboarding), Join App (registration)
 * Contains: business types, tags per type, default services per tag
 */

// ── Business Types ──────────────────────────────────────────────
export const BUSINESS_TYPES = [
  {id: 'fitness',  name: 'כושר ותנועה',      emoji: '🏋️', color: '#3B82F6', light: '#EFF6FF'},
  {id: 'beauty',   name: 'טיפוח ויופי',      emoji: '💇', color: '#EC4899', light: '#FDF2F8'},
  {id: 'wellness', name: 'גוף ונפש',         emoji: '🌿', color: '#10B981', light: '#ECFDF5'},
  {id: 'business', name: 'עסקים ושירותים',    emoji: '💼', color: '#8B5CF6', light: '#F5F3FF'},
  {id: 'medical',  name: 'רפואה וקליניקות',   emoji: '🩺', color: '#06B6D4', light: '#ECFEFF'},
  {id: 'other',    name: 'אחר',              emoji: '✨', color: '#F59E0B', light: '#FFFBEB'},
];

// ── Tags per Business Type ──────────────────────────────────────
export const BUSINESS_TAGS = {
  fitness: [
    {id: 'fitness_yoga',         name: 'יוגה',                emoji: '🧘'},
    {id: 'fitness_pilates',      name: 'פילאטיס',             emoji: '🤸'},
    {id: 'fitness_studio',       name: 'סטודיו לאימונים',     emoji: '🏋️'},
    {id: 'fitness_gym',          name: 'חדר כושר',            emoji: '💪'},
    {id: 'fitness_crossfit',     name: 'מועדון קרוספיט',      emoji: '🏋️'},
    {id: 'fitness_personal',     name: 'מאמן/ת (אישיים)',     emoji: '🏃'},
    {id: 'fitness_climbing',     name: 'קיר טיפוס',           emoji: '🧗'},
    {id: 'fitness_ninja',        name: 'מתחם נינג׳ה',         emoji: '🥷'},
    {id: 'fitness_martial',      name: 'אומנויות לחימה',      emoji: '🥋'},
    {id: 'fitness_dance',        name: 'סטודיו לריקוד',       emoji: '💃'},
    {id: 'fitness_outdoor',      name: 'אימוני חוץ',          emoji: '🏃'},
    {id: 'fitness_spinning',     name: 'ספינינג',             emoji: '🚴'},
    {id: 'fitness_classes',      name: 'חוגים',               emoji: '🎯'},
    {id: 'fitness_ems',          name: 'EMS',                 emoji: '⚡'},
    {id: 'fitness_pool',         name: 'פעילויות מים (בריכה)', emoji: '🏊'},
  ],
  beauty: [
    {id: 'beauty_hair',          name: 'מעצבי שיער',          emoji: '💇'},
    {id: 'beauty_barber',        name: 'ברברשופ',             emoji: '💈'},
    {id: 'beauty_nails',         name: 'מניקור ופדיקור',      emoji: '💅'},
    {id: 'beauty_facial',        name: 'טיפולי פנים',         emoji: '🧖'},
    {id: 'beauty_medical_aes',   name: 'אסתטיקה רפואית',     emoji: '💉'},
    {id: 'beauty_makeup',        name: 'איפור מקצועי',        emoji: '💄'},
    {id: 'beauty_permanent',     name: 'איפור קבוע',          emoji: '🖌️'},
    {id: 'beauty_tanning',       name: 'מכון שיזוף',          emoji: '🕶️'},
    {id: 'beauty_tattoo',        name: 'קעקועים ופירסינג',    emoji: '🎨'},
    {id: 'beauty_dental_aes',    name: 'אסתטיקה דנטלית',     emoji: '🦷'},
    {id: 'beauty_brows',         name: 'גבות ושפם',           emoji: '💈'},
    {id: 'beauty_laser',         name: 'לייזר והסרת שיער',    emoji: '🔧'},
    {id: 'beauty_lashes',        name: 'ריסים',               emoji: '👁️'},
    {id: 'beauty_pet_grooming',  name: 'מספרת כלבים',         emoji: '🐕'},
  ],
  wellness: [
    {id: 'wellness_spa',         name: 'מתחם ספא',            emoji: '🧖'},
    {id: 'wellness_massage',     name: 'עיסוי',               emoji: '💆'},
    {id: 'wellness_alternative', name: 'טיפולים משלימים',     emoji: '🌿'},
    {id: 'wellness_nutrition',   name: 'יועצי תזונה',         emoji: '🥗'},
    {id: 'wellness_coaching',    name: 'קואצ׳רים (אימון אישי)', emoji: '📈'},
    {id: 'wellness_mindfulness', name: 'מיינדפולנס',          emoji: '🧘'},
    {id: 'wellness_mental',      name: 'אימונים מנטליים',     emoji: '🧠'},
    {id: 'wellness_ice',         name: 'סדנאות קרח',          emoji: '🧊'},
  ],
  business: [
    {id: 'business_consulting',  name: 'ייעוץ עסקי',          emoji: '💼'},
    {id: 'business_coaching',    name: 'אימון עסקי',          emoji: '📋'},
    {id: 'business_accounting',  name: 'חשבונאות',            emoji: '🧮'},
    {id: 'business_legal',       name: 'שירותים משפטיים',     emoji: '⚖️'},
    {id: 'business_realestate',  name: 'נדל"ן',              emoji: '🏠'},
    {id: 'business_finance',     name: 'ייעוץ פיננסי',        emoji: '💰'},
    {id: 'business_marketing',   name: 'שיווק ופרסום',        emoji: '📊'},
    {id: 'business_design',      name: 'עיצוב גרפי',         emoji: '🎨'},
    {id: 'business_photography', name: 'צילום',               emoji: '📷'},
    {id: 'business_education',   name: 'חינוך והדרכה',        emoji: '📚'},
    {id: 'business_tutoring',    name: 'שיעורים פרטיים',      emoji: '🎓'},
    {id: 'business_tech',        name: 'טכנולוגיה ומחשבים',   emoji: '💻'},
  ],
  medical: [
    {id: 'medical_general',      name: 'רפואה כללית',         emoji: '🩺'},
    {id: 'medical_dental',       name: 'רפואת שיניים',        emoji: '🦷'},
    {id: 'medical_physio',       name: 'פיזיותרפיה',          emoji: '🦴'},
    {id: 'medical_psychology',   name: 'פסיכולוגיה',          emoji: '🧠'},
    {id: 'medical_dermatology',  name: 'דרמטולוגיה',          emoji: '🔬'},
    {id: 'medical_optometry',    name: 'אופטומטריה',          emoji: '👓'},
    {id: 'medical_pediatrics',   name: 'רפואת ילדים',         emoji: '👶'},
    {id: 'medical_orthopedics',  name: 'אורתופדיה',           emoji: '🦿'},
    {id: 'medical_speech',       name: 'קלינאות תקשורת',      emoji: '🗣️'},
    {id: 'medical_occupational', name: 'ריפוי בעיסוק',        emoji: '🖐️'},
    {id: 'medical_dietician',    name: 'תזונאי/ת קליני/ת',    emoji: '🥗'},
    {id: 'medical_chiropractic', name: 'כירופרקטיקה',         emoji: '🦴'},
  ],
  other: [
    {id: 'other_events',         name: 'אירועים',             emoji: '🎉'},
    {id: 'other_cleaning',       name: 'ניקיון ותחזוקה',      emoji: '🧹'},
    {id: 'other_automotive',     name: 'רכב ומוסכים',         emoji: '🚗'},
    {id: 'other_pets',           name: 'חיות מחמד',           emoji: '🐾'},
    {id: 'other_music',          name: 'מוזיקה',              emoji: '🎵'},
    {id: 'other_art',            name: 'אמנות ויצירה',        emoji: '🎨'},
    {id: 'other_spiritual',      name: 'רוחניות',             emoji: '✨'},
    {id: 'other_custom',         name: 'מותאם אישית',         emoji: '🔧'},
  ],
};

// ── Default Services per Tag (2 services each) ──────────────────
export const TAG_SERVICES = {
  // FITNESS
  fitness_yoga:     [{name: 'שיעור יוגה', duration: 60, price: 80, type: 'CLASS', max: 15}],
  fitness_pilates:  [{name: 'שיעור פילאטיס', duration: 55, price: 80, type: 'CLASS', max: 12}],
  fitness_studio:   [{name: 'אימון קבוצתי', duration: 50, price: 70, type: 'CLASS', max: 20}],
  fitness_gym:      [{name: 'אימון חדר כושר', duration: 60, price: 50, type: 'CLASS', max: 30}],
  fitness_crossfit: [{name: 'WOD קבוצתי', duration: 60, price: 70, type: 'CLASS', max: 20}],
  fitness_personal: [{name: 'אימון אישי', duration: 60, price: 200, type: 'REGULAR', max: 1}],
  fitness_climbing: [{name: 'שיעור טיפוס', duration: 90, price: 100, type: 'CLASS', max: 10}],
  fitness_ninja:    [{name: 'מסלול נינג׳ה', duration: 60, price: 90, type: 'CLASS', max: 15}],
  fitness_martial:  [{name: 'שיעור לחימה', duration: 60, price: 80, type: 'CLASS', max: 20}],
  fitness_dance:    [{name: 'שיעור ריקוד', duration: 60, price: 70, type: 'CLASS', max: 20}],
  fitness_outdoor:  [{name: 'אימון חוץ קבוצתי', duration: 60, price: 60, type: 'CLASS', max: 15}],
  fitness_spinning: [{name: 'שיעור ספינינג', duration: 45, price: 60, type: 'CLASS', max: 25}],
  fitness_classes:  [{name: 'חוג קבוצתי', duration: 60, price: 70, type: 'CLASS', max: 20}],
  fitness_ems:      [{name: 'אימון EMS', duration: 25, price: 150, type: 'REGULAR', max: 1}],
  fitness_pool:     [{name: 'שיעור שחייה', duration: 45, price: 100, type: 'CLASS', max: 8}],

  // BEAUTY
  beauty_hair:         [{name: 'תספורת', duration: 45, price: 120, type: 'REGULAR', max: 1}],
  beauty_barber:       [{name: 'תספורת גבר', duration: 30, price: 80, type: 'REGULAR', max: 1}],
  beauty_nails:        [{name: 'מניקור', duration: 45, price: 100, type: 'REGULAR', max: 1}],
  beauty_facial:       [{name: 'טיפול פנים', duration: 60, price: 250, type: 'REGULAR', max: 1}],
  beauty_medical_aes:  [{name: 'בוטוקס', duration: 30, price: 800, type: 'REGULAR', max: 1}],
  beauty_makeup:       [{name: 'איפור אירוע', duration: 60, price: 400, type: 'REGULAR', max: 1}],
  beauty_permanent:    [{name: 'איפור קבוע שפתיים', duration: 90, price: 1500, type: 'REGULAR', max: 1}],
  beauty_tanning:      [{name: 'שיזוף מכונה', duration: 15, price: 50, type: 'REGULAR', max: 1}],
  beauty_tattoo:       [{name: 'קעקוע קטן', duration: 60, price: 500, type: 'REGULAR', max: 1}],
  beauty_dental_aes:   [{name: 'הלבנת שיניים', duration: 60, price: 800, type: 'REGULAR', max: 1}],
  beauty_brows:        [{name: 'עיצוב גבות', duration: 20, price: 60, type: 'REGULAR', max: 1}],
  beauty_laser:        [{name: 'הסרת שיער בלייזר', duration: 30, price: 300, type: 'REGULAR', max: 1}],
  beauty_lashes:       [{name: 'הלחמת ריסים', duration: 90, price: 350, type: 'REGULAR', max: 1}],
  beauty_pet_grooming: [{name: 'גזירה + רחצה', duration: 90, price: 200, type: 'REGULAR', max: 1}],

  // WELLNESS
  wellness_spa:         [{name: 'חבילת ספא', duration: 120, price: 500, type: 'REGULAR', max: 1}],
  wellness_massage:     [{name: 'עיסוי שוודי', duration: 60, price: 280, type: 'REGULAR', max: 1}],
  wellness_alternative: [{name: 'דיקור סיני', duration: 60, price: 300, type: 'REGULAR', max: 1}],
  wellness_nutrition:   [{name: 'מפגש ייעוץ תזונה', duration: 50, price: 350, type: 'REGULAR', max: 1}],
  wellness_coaching:    [{name: 'מפגש אימון אישי', duration: 60, price: 400, type: 'REGULAR', max: 1}],
  wellness_mindfulness: [{name: 'שיעור מיינדפולנס', duration: 60, price: 80, type: 'CLASS', max: 15}],
  wellness_mental:      [{name: 'אימון מנטלי', duration: 50, price: 350, type: 'REGULAR', max: 1}],
  wellness_ice:         [{name: 'סדנת קרח', duration: 90, price: 150, type: 'CLASS', max: 10}],

  // BUSINESS
  business_consulting:  [{name: 'פגישת ייעוץ', duration: 60, price: 400, type: 'REGULAR', max: 1}],
  business_coaching:    [{name: 'אימון אישי', duration: 60, price: 400, type: 'REGULAR', max: 1}],
  business_accounting:  [{name: 'פגישת ייעוץ מס', duration: 45, price: 350, type: 'REGULAR', max: 1}],
  business_legal:       [{name: 'ייעוץ משפטי', duration: 60, price: 500, type: 'REGULAR', max: 1}],
  business_realestate:  [{name: 'פגישת ייעוץ נדל"ן', duration: 45, price: 0, type: 'REGULAR', max: 1}],
  business_finance:     [{name: 'ייעוץ פיננסי', duration: 60, price: 400, type: 'REGULAR', max: 1}],
  business_marketing:   [{name: 'אסטרטגיית שיווק', duration: 60, price: 350, type: 'REGULAR', max: 1}],
  business_design:      [{name: 'פגישת עיצוב', duration: 60, price: 300, type: 'REGULAR', max: 1}],
  business_photography: [{name: 'צילום אירוע', duration: 180, price: 2000, type: 'REGULAR', max: 1}],
  business_education:   [{name: 'הדרכה פרטית', duration: 60, price: 300, type: 'REGULAR', max: 1}],
  business_tutoring:    [{name: 'שיעור פרטי', duration: 60, price: 150, type: 'REGULAR', max: 1}],
  business_tech:        [{name: 'ייעוץ טכנולוגי', duration: 60, price: 400, type: 'REGULAR', max: 1}],

  // MEDICAL
  medical_general:      [{name: 'ביקור רופא', duration: 20, price: 250, type: 'REGULAR', max: 1}],
  medical_dental:       [{name: 'בדיקה + ניקוי', duration: 45, price: 350, type: 'REGULAR', max: 1}],
  medical_physio:       [{name: 'טיפול פיזיותרפיה', duration: 45, price: 300, type: 'REGULAR', max: 1}],
  medical_psychology:   [{name: 'פגישה טיפולית', duration: 50, price: 450, type: 'REGULAR', max: 1}],
  medical_dermatology:  [{name: 'ביקור דרמטולוג', duration: 20, price: 350, type: 'REGULAR', max: 1}],
  medical_optometry:    [{name: 'בדיקת עיניים', duration: 30, price: 200, type: 'REGULAR', max: 1}],
  medical_pediatrics:   [{name: 'ביקור ילדים', duration: 20, price: 300, type: 'REGULAR', max: 1}],
  medical_orthopedics:  [{name: 'ביקור אורתופד', duration: 20, price: 400, type: 'REGULAR', max: 1}],
  medical_speech:       [{name: 'טיפול קלינאות', duration: 45, price: 350, type: 'REGULAR', max: 1}],
  medical_occupational: [{name: 'טיפול ריפוי בעיסוק', duration: 45, price: 300, type: 'REGULAR', max: 1}],
  medical_dietician:    [{name: 'ייעוץ תזונתי', duration: 45, price: 350, type: 'REGULAR', max: 1}],
  medical_chiropractic: [{name: 'טיפול כירופרקטי', duration: 30, price: 300, type: 'REGULAR', max: 1}],

  // OTHER
  other_events:    [{name: 'ארגון אירוע', duration: 60, price: 500, type: 'REGULAR', max: 1}],
  other_cleaning:  [{name: 'ניקיון בית', duration: 180, price: 300, type: 'REGULAR', max: 1}],
  other_automotive:[{name: 'טיפול רכב', duration: 60, price: 200, type: 'REGULAR', max: 1}],
  other_pets:      [{name: 'ביקור וטרינר', duration: 30, price: 200, type: 'REGULAR', max: 1}],
  other_music:     [{name: 'שיעור מוזיקה', duration: 45, price: 150, type: 'REGULAR', max: 1}],
  other_art:       [{name: 'שיעור ציור', duration: 90, price: 120, type: 'CLASS', max: 10}],
  other_spiritual: [{name: 'טיפול רוחני', duration: 60, price: 300, type: 'REGULAR', max: 1}],
  other_custom:    [{name: 'פגישה ראשונה', duration: 60, price: 200, type: 'REGULAR', max: 1}],
};

// ── Max tag selections ──────────────────────────────────────────
export const MAX_TAG_SELECTIONS = 4;

// ── Helper Functions ────────────────────────────────────────────

export const getBusinessType = (typeId) =>
  BUSINESS_TYPES.find(t => t.id === typeId);

export const getTagsForType = (typeId) =>
  BUSINESS_TAGS[typeId] || [];

export const getServicesForTag = (tagId) =>
  TAG_SERVICES[tagId] || [];

export const generateServicesFromTags = (tagIds = []) => {
  const services = [];
  const seenNames = new Set();
  tagIds.forEach(tagId => {
    const tagServices = TAG_SERVICES[tagId] || [];
    tagServices.forEach(svc => {
      if (!seenNames.has(svc.name)) {
        seenNames.add(svc.name);
        services.push({...svc, tagId});
      }
    });
  });
  return services;
};
